// extracted by mini-css-extract-plugin
export var employee = "styles-module--employee--1PJiL";
export var employee_img = "styles-module--employee_img--1yqUv";
export var employee_info = "styles-module--employee_info--XMukB";
export var employee_info_name = "styles-module--employee_info_name--2xvzp";
export var employee_info_pos = "styles-module--employee_info_pos--1sp2J";
export var employee_info_btns = "styles-module--employee_info_btns--9zMsH";
export var employee_info_btns_btn = "styles-module--employee_info_btns_btn--2L_Eg";
export var employee_info_btns_arrow = "styles-module--employee_info_btns_arrow--1Xev0";
export var jsAnimInit = "styles-module--jsAnimInit--AirgK";